import React from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import { TypographyChatActivityLastMessage_EmbedChatActivity$key } from './__generated__/TypographyChatActivityLastMessage_EmbedChatActivity.graphql';
import TypographyMessageText, { TypographyMessageTextProps } from './TypographyMessageText';

export interface TypographyChatActivityLastMessageProps
  extends Omit<TypographyMessageTextProps, 'classes' | 'fragmentRef'> {
  fragmentRef: TypographyChatActivityLastMessage_EmbedChatActivity$key;
}

const TypographyChatActivityLastMessage: React.FC<TypographyChatActivityLastMessageProps> = ({
  fragmentRef,
  ...rest
}) => {
  const chatActivity = useFragment<TypographyChatActivityLastMessage_EmbedChatActivity$key>(
    graphql`
      fragment TypographyChatActivityLastMessage_EmbedChatActivity on ChatActivity {
        lastMessage {
          ...TypographyMessageText_EmbedMessage
        }
      }
    `,
    fragmentRef,
  );

  if (!chatActivity.lastMessage) {
    return null;
  }
  return <TypographyMessageText fragmentRef={chatActivity.lastMessage} {...rest} />;
};

export default TypographyChatActivityLastMessage;
